import BaseException from '../base_exception'

class BindFile extends BaseException {
  constructor(resource, idToBind, filesWithContextIds) {
    super('hs.file.bind_to', { resource, idToBind, filesWithContextIds })
  }
}

export default BindFile
